import Context from "../../context/Context";
import FieldNames from "../../aiim/datasets/FieldNames";
import Source from "../../aiim/base/Source";
import * as aiimUtil from "../../aiim/util/aiimUtil";
import * as queryUtil from "./queryUtil";

export function getInitialPeopleSource() {
  const aiim = Context.instance.aiim;
  const dataset = aiim && aiim.datasets && aiim.datasets.people;
  const layer = dataset && dataset.layer2D;
  const source = layer && layer.xtnAiim && layer.xtnAiim.source;
  return source;
}

export function getInitialUnitsSource() {
  const aiim = Context.instance.aiim;
  const dataset = aiim && aiim.datasets && aiim.datasets.units;
  const layer = dataset && dataset.layer2D;
  const source = layer && layer.xtnAiim && layer.xtnAiim.source;
  return source;
}

export function getPeopleLayer() {
  const source = getPeopleSource();
  return source && source.layer2D;
}

export function getPeopleSource() {
  let plan = Context.instance.spaceplanner.activePlan;
  if (plan) return plan.planPeopleSource;
}

export function getPeopleSourceKey() {
  return "People";
}

export function getSourceByKey(sourceKey) {
  //const aiim = Context.instance.aiim;
  //return aiim && aiim.getSource(this.getSourceKey());

  // let plan = Context.instance.spaceplanner.activePlan;
  // if (plan) {
  //   if (sourceKey === getPeopleSourceKey()) {
  //     return plan.planPeopleSource;
  //   } else if (sourceKey === getUnitsSourceKey()) {
  //     return plan.planUnitsSource;
  //   }
  // }

  if (sourceKey === getPeopleSourceKey()) {
    return getPeopleSource();
  } else if (sourceKey === getUnitsSourceKey()) {
    return getUnitsSource();
  }

}

export function getUnitsLayer() {
  const source = getUnitsSource();
  return source && source.layer2D;
}

export function getUnitsSource() {
  let plan = Context.instance.spaceplanner.activePlan;
  if (plan) return plan.planUnitsSource;
}

export function getUnitsSourceKey() {
  return "Units";
}

export function hasFields(layer,names,geometryType) {
  if (!layer) return false;
  if (geometryType) {
    if (geometryType === "point" && layer.geometryType === "esriGeometryPoint") {
      geometryType = "esriGeometryPoint";
    }
    if (geometryType === "polygon" && layer.geometryType === "esriGeometryPolygon") {
      geometryType = "esriGeometryPolygon";
    }
  }
  if (geometryType && geometryType !== layer.geometryType) return false;
  return names.every(name => {
    return !!aiimUtil.findField(layer.fields,name);
  });
}

export function hasAreasFields(table) {
  const names = ["area_id","area_name","area_type"];
  return hasFields(table,names);
}

export function hasPeopleFields(layer,forSpaceplanner) {
  const names = ["knownas","site_id","facility_id","level_id","level_number","unit_id"];
  if (forSpaceplanner) names.push("area_id","org_level_1","org_level_2","job_title","start_date");
  return hasFields(layer,names,"point");
}

export function hasUnitsFields(layer,forSpaceplanner) {
  const names = ["access_type","use_type","site_id","facility_id","level_id","level_number"];
  if (forSpaceplanner) names.push("area_id","assignment_type");
  return hasFields(layer,names,"polygon");
}

export function makePlanSources(task) {
  const promises = [];
  const peopleLayer = task.plan.peopleLayer;
  const unitsLayer = task.plan.unitsLayer;
  if (peopleLayer) {
    let layer = peopleLayer;
    task.plan.peopleSource = new Source({
      key: getPeopleSourceKey(),
      name: layer.title,
      url: layer.url+"/"+layer.layerId,
      layer2D: layer
    });
    let v = FieldNames.PEOPLE_FULLNAME;
    if (layer && aiimUtil.findField(layer.fields,v)) {
      task.plan.peopleSource.displayField = v;
    }
    layer.xtnAiim = {
      isPlanLayer: true,
      requiresFacilityMode: true,
      source: task.plan.peopleSource
    };
    promises.push(task.plan.peopleSource.checkSchema());
  }
  if (unitsLayer) {
    let layer = unitsLayer;
    task.plan.unitsSource = new Source({
      key: getUnitsSourceKey(),
      name: layer.title,
      url: layer.url+"/"+layer.layerId,
      layer2D: layer
    });
    layer.xtnAiim = {
      isPlanLayer: true,
      requiresFacilityMode: true,
      source: task.plan.unitsSource
    };
    promises.push(task.plan.unitsSource.checkSchema());
  }
  return Promise.all(promises);
}

export function queryLastEditDate(source){
  const layer = source.layer2D;
  const promise=new Promise((resolve,reject) => {
  if(layer && layer.editFieldsInfo){
    const modifiedDate=layer.editFieldsInfo.editDateField;
    const fields = source.layer2D.fields;
    if(modifiedDate){
      const dateField = aiimUtil.findField(fields,modifiedDate);
      const maxDateStat = {
        onStatisticField: dateField.name,
        outStatisticFieldName: "maxDate",
        statisticType: "max"
      };
      const maxDateStatOptions = {
        source: source,
        outStatistics: maxDateStat,
        where: "1=1"
      };
      queryUtil.queryStats(maxDateStatOptions).then(result=>{
        const maxDate=result.features[0].attributes.maxDate;
        resolve(maxDate);
      }).catch(error=>{
        reject(error);
      })
    }else{
      resolve();
    }
  }else{
    resolve();
  }
})
return promise; 
}

